"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemSchema = void 0;
/**
 *  The validation schema for a system.
 */
exports.SystemSchema = {
    type: 'object',
    required: [
        'brand',
        'productLine',
        'installationLocation',
        'filterTechnology',
        'coolingEnergyLabel',
        'heatingEnergyLabel',
        'sku',
        'minimum_cooling_capacity',
        'maximum_cooling_capacity',
        'minimum_heating_capacity',
        'maximum_heating_capacity',
    ],
    properties: {
        guid: { type: ['string', 'null'] },
        brand: { type: ['object', 'string'] },
        productLine: { type: ['object', 'string'] },
        installationLocation: { type: ['object', 'string'] },
        filterTechnology: { type: ['object', 'string'] },
        coolingEnergyLabel: { type: ['object', 'string'] },
        heatingEnergyLabel: { type: ['object', 'string'] },
        sku: { type: 'string', minLength: 4, maxLength: 100 },
        description: { type: ['string', 'null'] },
        wifi: { type: ['boolean', 'null'], default: false },
        minimum_cooling_capacity: { type: 'number', maxLength: 10 },
        maximum_cooling_capacity: { type: 'number', maxLength: 10 },
        minimum_heating_capacity: { type: 'number', maxLength: 10 },
        maximum_heating_capacity: { type: 'number', maxLength: 10 },
        index: { type: ['number', 'null'], minLength: 1, maxLength: 11, default: 1 },
        updated_at: { type: ['string', 'null'] },
        created_at: { type: ['string', 'null'] },
    },
};
//# sourceMappingURL=system.schema.js.map